module.exports = __webpack_public_path__ + "static/media/hint-modal-icon.d840bbfa.svg";